import { forwardRef } from 'react';
import type { CSSProperties, HTMLAttributes } from 'react';
import { kaiFontFamily } from '../../../../core/tokens';
import { REVIEW_COLORS, REVIEW_RADII, REVIEW_SPACING } from '../reviewFlowTokens';
import {
  resolveStyleOverride,
  type StyleOverride,
} from '../styleOverrides';

const SURFACE_STYLE: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: REVIEW_SPACING.medium,
  background: REVIEW_COLORS.canvas,
  color: REVIEW_COLORS.text,
  borderRadius: REVIEW_RADII.large,
  fontFamily: kaiFontFamily,
};

export interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  styleOverride?: StyleOverride;
}

export const Surface = forwardRef<HTMLDivElement, SurfaceProps>(
  ({ styleOverride: surfaceCss, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        style={{
          ...SURFACE_STYLE,
          ...style,
          ...resolveStyleOverride(surfaceCss),
        }}
        {...props}
      />
    );
  },
);

Surface.displayName = 'Surface';
